module.exports = __webpack_public_path__ + "static/media/device-reset.ca7f6404.png";